import { useState } from "react";
import PromineoPopover from "components/common/controls/PromineoPopover";
import { Offset, Position } from "devextreme-react/popover";
import { useHistory } from "react-router";
import SubNavMenuePopover from "../navigation-bar/SubNavMenuePopover";
import NavItemOption from "interfaces/NavItemOption";

interface Props {
  items: NavItemOption[];
  onMoreButtonActiveStatusChange: (isActive: boolean) => void;
}

export default function PriorityNavMoreButton(props: Props) {
  const { items } = props;
  const history = useHistory();

  const [isSubRoutesVisible, setIsSubRoutesVisible] = useState(false);
  const [isMoreOptionsShouldDisplayed, setIsMoreOptionsShouldDisplayed] =
    useState(false);

  const closeMoreOptions = () => {
    setIsMoreOptionsShouldDisplayed(false);
    props.onMoreButtonActiveStatusChange(false);
  };

  const displayMoreOptions = () => {
    const isAlreadyDisplayed = isMoreOptionsShouldDisplayed;
    setIsMoreOptionsShouldDisplayed(!isAlreadyDisplayed);
    props.onMoreButtonActiveStatusChange(!isAlreadyDisplayed);
  };

  const handleMenuItemClick = (selectedItem: NavItemOption) => {
    if (selectedItem.children?.length) {
      setIsSubRoutesVisible(true);
    } else if (selectedItem.route) {
      history.push(selectedItem.route);
    }
  };

  const Content = () => {
    return (
      <>
        {(items || []).map((item) => {
          return (
            <div key={item.itemId}>
              <div
                id={`priority-nav-more-items-menu-${item.itemId}`}
                className="block cursor-pointer py-1 pl-2 pr-16 font-medium hover:bg-promGray3 active:bg-promGray3 rounded-sm"
                onClick={() => handleMenuItemClick(item)}
              >
                {item.text}
              </div>
              {item.children &&
                item.children.length > 0 &&
                isSubRoutesVisible && (
                  <SubNavMenuePopover
                    menuItems={item.children}
                    target={`#priority-nav-more-items-menu-${item.itemId}`}
                    onClose={() => setIsSubRoutesVisible(false)}
                    onSelect={() => setIsSubRoutesVisible(false)}
                    yOffset={15}
                  />
                )}
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div>
      <div onClick={displayMoreOptions} id="moreNavItems">
        <i className="icon dx-icon-more font-bold" />
      </div>
      <div>
        {isMoreOptionsShouldDisplayed && (
          <PromineoPopover
            width={"auto"}
            height={"auto"}
            visible={true}
            closeOnOutsideClick={true}
            onHiding={closeMoreOptions}
            target={"#moreNavItems"}
          >
            <Position my={{ x: "right", y: "top" }}>
              <Offset y={25} x={26} />
            </Position>
            <Content />
          </PromineoPopover>
        )}
      </div>
    </div>
  );
}
